// src/index.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { DEFAULT_LIGHTING_ADJUSTMENT } from "@hoverinc/rendering-compositor-react";
import { Leva, button, folder, useControls } from "leva";
import { useCallback, useEffect, useRef as useRef2, useState } from "react";
// src/Histogram/index.ts
import { createPlugin } from "leva/plugin";
// src/Histogram/Histogram.tsx
import { useSize } from "@chakra-ui/react-use-size";
import { Components, useInputContext } from "leva/plugin";
import { useMemo, useRef } from "react";
// src/Histogram/StyledHistogram.tsx
import { styled } from "leva/plugin";
var Container = styled("div", {
    width: "100%",
    height: "4rem"
});
var Svg = styled("svg", {
    overflow: "visible",
    width: "100%",
    height: "100%"
});
var Bar = styled("rect", {
    fill: "$highlight3",
    transformOrigin: "bottom"
});
var LineMarkLine = styled("line", {
    stroke: "$accent1",
    strokeWidth: "1px"
});
var ValueMarkLine = styled("line", {
    stroke: "currentColor",
    strokeWidth: "1px"
});
var ValueMarkCircle = styled("circle", {
    fill: "currentColor"
});
// src/Histogram/Histogram.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Label = Components.Label, Row = Components.Row;
var LineMark = function(_param) /* @__PURE__ */ {
    var ref = _param.ref, height = _param.height, x = _param.x, y = _param.y, props = _objectWithoutProperties(_param, [
        "ref",
        "height",
        "x",
        "y"
    ]);
    return jsx("g", _objectSpreadProps(_objectSpread({
        transform: "translate(".concat(x, ", ").concat(y, ")")
    }, props), {
        children: /* @__PURE__ */ jsx(LineMarkLine, {
            x1: 0,
            x2: 0,
            y1: 0,
            y2: height
        })
    }));
};
var ValueMark = function(_param) /* @__PURE__ */ {
    var ref = _param.ref, height = _param.height, x = _param.x, y = _param.y, props = _objectWithoutProperties(_param, [
        "ref",
        "height",
        "x",
        "y"
    ]);
    return jsxs("g", _objectSpreadProps(_objectSpread({
        transform: "translate(".concat(x, ", ").concat(y, ")")
    }, props), {
        style: {
            transition: "transform 0.5s ease-in-out"
        },
        children: [
            /* @__PURE__ */ jsx(ValueMarkCircle, {
                cx: 0,
                cy: 0,
                r: 3
            }),
            /* @__PURE__ */ jsx(ValueMarkLine, {
                x1: 0,
                x2: 0,
                y1: 0,
                y2: height
            })
        ]
    }));
};
var Histogram = function() {
    var _useInputContext = useInputContext(), label = _useInputContext.label, _useInputContext_value = _useInputContext.value, histogram2 = _useInputContext_value.histogram, max = _useInputContext_value.max, marks = _useInputContext_value.marks;
    var containerRef = useRef(null);
    var containerSize = useSize(containerRef);
    var _ref = containerSize !== null && containerSize !== void 0 ? containerSize : {
        width: 200,
        height: 50
    }, width = _ref.width, height = _ref.height;
    var _useMemo = _slicedToArray(useMemo(function() {
        var _Math;
        var maxCount = max !== null && max !== void 0 ? max : (_Math = Math).max.apply(_Math, _toConsumableArray(histogram2));
        var barWidth = width / histogram2.length;
        var offset = 0;
        var heightMultiplier = height / maxCount;
        var lineMarkers = [];
        var valueMarkers = [];
        var bars = histogram2.map(function(count, i) {
            var barHeight = count >= maxCount ? height : count * heightMultiplier;
            var x = i * barWidth + offset;
            var y = height - barHeight;
            marks === null || marks === void 0 ? void 0 : marks.filter(function(param) {
                var index = param.index;
                return index === i;
            }).forEach(function(mark) {
                if (mark.type === "line") {
                    lineMarkers.push(/* @__PURE__ */ jsx(LineMark, {
                        height: height,
                        width: barWidth,
                        x: x,
                        y: 0
                    }, "line-mark-".concat(i)));
                }
                if (mark.type === "value") {
                    valueMarkers.push(/* @__PURE__ */ jsx(ValueMark, {
                        color: mark.color,
                        height: barHeight,
                        width: barWidth,
                        x: x,
                        y: y
                    }, "value-mark-".concat(i)));
                }
            });
            return /* @__PURE__ */ jsx(Bar, {
                height: barHeight,
                width: barWidth,
                x: x,
                y: y
            }, "bar-".concat(i));
        });
        return [
            bars,
            lineMarkers,
            valueMarkers
        ];
    }, [
        height,
        histogram2,
        marks,
        max,
        width
    ]), 3), barElements = _useMemo[0], lineMarkerElements = _useMemo[1], valueMarkerElements = _useMemo[2];
    return /* @__PURE__ */ jsxs(Row, {
        children: [
            /* @__PURE__ */ jsx(Label, {
                children: label
            }),
            /* @__PURE__ */ jsx(Container, {
                ref: containerRef,
                children: /* @__PURE__ */ jsxs(Svg, {
                    viewBox: "0 0 ".concat(width, " ").concat(height),
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        barElements,
                        lineMarkerElements,
                        valueMarkerElements
                    ]
                })
            })
        ]
    });
};
// src/Histogram/index.ts
var defaultSettings = {};
var sanitize = function(param, settings) {
    var histogram2 = param.histogram, max = param.max, marks = param.marks;
    return {
        histogram: histogram2,
        max: max,
        marks: marks,
        settings: settings
    };
};
var format = function(value, settings) {
    return {
        histogram: value.histogram,
        settings: settings
    };
};
var normalize = function(_param) {
    var histogram2 = _param.histogram, max = _param.max, marks = _param.marks, _settings = _objectWithoutProperties(_param, [
        "histogram",
        "max",
        "marks"
    ]);
    var settings = _objectSpread({}, defaultSettings, _settings);
    var defaultHistogram = histogram2 !== null && histogram2 !== void 0 ? histogram2 : [];
    return {
        value: {
            histogram: defaultHistogram,
            max: max,
            marks: marks
        },
        settings: settings
    };
};
var histogram = createPlugin({
    normalize: normalize,
    sanitize: sanitize,
    format: format,
    component: Histogram
});
// src/index.ts
import { folder as folder2 } from "leva";
var defaults = {
    gamma: DEFAULT_LIGHTING_ADJUSTMENT.gammaCorrection,
    threshold: 0.5,
    adjustment: true,
    exclusion: 1
};
var debug = function(param) {
    var compositor = param.compositor, setScale = param.setScale, scale = param.scale, sceneScale = param.sceneScale, fixLighting = param.fixLighting;
    var _useState = _slicedToArray(useState(compositor), 2), previousCompositor = _useState[0], setPreviousCompositor = _useState[1];
    var scaleRef = useRef2(sceneScale);
    scaleRef.current = sceneScale;
    var _useControls = _slicedToArray(useControls(function() {
        return {
            reset: button(function() {
                return set(_objectSpreadProps(_objectSpread({}, defaults), {
                    scale: scaleRef.current
                }));
            }),
            adjustment: {
                value: fixLighting
            },
            scale: {
                value: scale,
                min: 0.01,
                max: 15,
                step: 0.01,
                onChange: function(s) {
                    return setScale(s);
                }
            },
            gamma: {
                value: defaults.gamma,
                min: 1,
                max: 3,
                step: 0.05
            },
            shadows: folder({
                threshold: {
                    value: defaults.threshold,
                    min: 0,
                    max: 3,
                    step: 0.05
                },
                exclusion: {
                    value: defaults.exclusion,
                    min: 0,
                    max: 2,
                    step: 0.05
                },
                histogram: histogram({
                    histogram: []
                })
            })
        };
    }), 3), controls = _useControls[0], set = _useControls[1], get = _useControls[2];
    var onLightingAdjustmentChange = useCallback(function(param) {
        var adjustment = param.adjustment;
        set({
            adjustment: adjustment.enabled,
            gamma: adjustment.gammaCorrection
        });
    }, [
        set
    ]);
    var onLightingDataChange = useCallback(function(event) {
        if (!event.data) return;
        var _event_data = event.data, histogramRaw = _event_data.histogramRaw, peakLevel = _event_data.peakLevel, markers = _event_data.markers;
        set({
            histogram: {
                histogram: histogramRaw !== null && histogramRaw !== void 0 ? histogramRaw : [],
                max: peakLevel,
                marks: [
                    {
                        type: "value",
                        label: "Threshold",
                        index: markers.threshold,
                        color: "tomato"
                    },
                    {
                        type: "value",
                        label: "Peak",
                        index: markers.peak,
                        color: "mediumvioletred"
                    },
                    {
                        type: "line",
                        label: "Low",
                        index: markers.low
                    },
                    {
                        type: "line",
                        label: "High",
                        index: markers.high
                    }
                ]
            }
        });
    }, [
        set
    ]);
    useEffect(function() {
        return set({
            scale: scale
        });
    }, [
        scale,
        set
    ]);
    useEffect(function() {
        if (compositor) compositor.updateLightingAjustment({
            enabled: get("adjustment")
        });
    }, [
        compositor,
        controls.adjustment,
        get
    ]);
    useEffect(function() {
        if (compositor) compositor.updateLightingAjustment({
            gammaCorrection: get("gamma")
        });
    }, [
        compositor,
        controls.gamma,
        get
    ]);
    useEffect(function() {
        if (compositor) compositor.shadowThreshold = get("threshold");
    }, [
        compositor,
        controls.threshold,
        get
    ]);
    useEffect(function() {
        if (compositor) compositor.shadowExclusion = get("exclusion");
    }, [
        compositor,
        controls.exclusion,
        get
    ]);
    var cleanup = useCallback(function(c) {
        if (!c) return;
        c.removeEventListener("lighting-adjustment", onLightingAdjustmentChange);
    }, [
        onLightingAdjustmentChange
    ]);
    if (compositor !== previousCompositor) {
        cleanup(compositor);
        setPreviousCompositor(compositor);
    }
    useEffect(function() {
        if (compositor) {
            compositor.addEventListener("lighting-adjustment", onLightingAdjustmentChange);
            compositor.addEventListener("lighting-data", onLightingDataChange);
        }
        return function() {
            return cleanup(compositor);
        };
    }, [
        cleanup,
        compositor,
        onLightingAdjustmentChange,
        onLightingDataChange
    ]);
};
export { Leva as Debug, debug, folder2 as folder, useControls as useDebugControls };
//# sourceMappingURL=index.js.map